// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tyranitar_mega: PokeData = {
  "id": 10049,
  "name": "tyranitar-mega",
  "height": 25,
  "weight": 2550,
  "base_experience": 315,
  "types": [
    PokeType.ROCK,
    PokeType.DARK
  ],
  "api_moves": [
    "thrash",
    "leer",
    "bite",
    "hyper-beam",
    "earthquake",
    "screech",
    "rock-slide",
    "scary-face",
    "sandstorm",
    "crunch",
    "payback",
    "dark-pulse",
    "giga-impact",
    "thunder-fang",
    "ice-fang",
    "fire-fang",
    "stone-edge",
    "chip-away"
  ],
  "moves": [
    "leer",
    "bite",
    "earthquake",
    "rock-slide",
    "scary-face",
    "sandstorm",
    "crunch",
    "dark-pulse",
    "thunder-fang",
    "ice-fang",
    "fire-fang",
    "stone-crush",
    "stone-axe"
  ],
  "evolution_chain": {
    "id": 126,
    "item": null,
    "species": [
      {
        "name": "larvitar",
        "order": 271,
        "types": [
          PokeType.ROCK,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "pupitar",
        "order": 272,
        "types": [
          PokeType.ROCK,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 246,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "tyranitar",
        "order": 273,
        "types": [
          PokeType.ROCK,
          PokeType.DARK
        ],
        "evolves_from_species_id": 247,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 55,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 81,
    "ability_power": 186
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
